
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIslandActions } from './island/IslandProvider';
import EmailVerfassen from '../pages/admin/emails/EmailVerfassen';
import { baueWeiterleitungCompose, markiereWeitergeleitet } from '../lib/rechnungen/weiterleitung';
import KorrekturAnfordernModal from './rechnungen/KorrekturAnfordernModal';
import KorrekturVerknuepfenModal from './rechnungen/KorrekturVerknuepfenModal';
import { baueKorrekturCompose, markiereKorrekturAngefordert, ladeKorrekturPartner, verknuepfeKorrektur, loeseKorrekturVerknuepfung, ziehKorrekturAnforderungZurueck, KurzRechnung } from '../lib/rechnungen/korrekturApi';
import { darfKorrekturAnfordern, wartetAufKorrektur, korrekturFehlerText } from '../lib/rechnungen/korrektur';
import { poolGrund } from '../lib/rechnungen/poolGrund';
import { verwendungszweckAnzeige } from '../lib/rechnungen/verwendungszweck';
import { eigentuemerAnzeigename, ansprechpartnerZusatz, istFirma } from '../lib/eigentuemer/anzeige';
import {
  Archive, ArrowBendUpLeft, ArrowBendUpRight, ArrowCounterClockwise, ArrowLineDown, ArrowLineUp, ArrowSquareOut, ArrowsLeftRight, ArrowUUpLeft, Bank,
  Buildings, CalendarBlank, CaretDown, FloppyDisk, GlobeSimple, MagnifyingGlass, User, UsersThree, type Icon as PhIcon, CaretLeft, CaretUp, CaretUpDown, Check, CheckCircle, Circle, CircleNotch, Clock, ClockCounterClockwise, DownloadSimple,
  Eye, Flag, FlowArrow, HandCoins, Link as LinkIcon, NotePencil, PaperPlaneTilt, PencilSimple, QrCode, Receipt, ShieldCheck, ShieldWarning, Sparkle,
  TrayArrowDown, Trash, UserCheck, UserCircle, WarningCircle, Wrench, X,
} from '@phosphor-icons/react';
import { AktionsZeile, BetragKachel, DetailChip, InfoZeile, KopierKnopf, VERLAUF_ICON, WerkzeugKnopf, Widget } from '../pages/admin/rechnungen/detail/DetailTeile';
import { statusLabelDe, statusTon } from '../lib/rechnungenAnsicht/darstellung';
import { useAppMeldungen } from './ui/AppMeldungen';
import { useMobilModus } from '../lib/immobilien/mobil';
import { useViewport } from './island/hooks';
import { Segment } from './ui/Segment';
import { exportSingleRechnungPdf } from '../lib/export/exportRechnungPdf';
import { supabase } from '../lib/supabase/client';
import PaymentQRModal from './PaymentQRModal';
import { BestaetigenDialog } from './immobilien/ui/BestaetigenDialog';
import { Rechnung } from './InvoicesView';
import { Rechnung35aBox } from './buchhaltung/Paragraph35a';
import { TimelineEvent, TIMELINE_CONFIG, WorkflowState } from '../lib/rechnungen/types';
import { fetchTimeline, addKommentar } from '../lib/rechnungen/timeline';
import { addTimelineEvent } from '../lib/rechnungen/timeline';
import EigentuemerEntscheidung from './rechnungen/EigentuemerEntscheidung';
import { getWorkflowState, requestTechPruefung, respondTechPruefung, requestFreigabe, respondFreigabe, markAsBezahlt, changeZuweisung } from '../lib/rechnungen/workflow';
import { getFaelligkeitsBadge, getRichtung, RICHTUNG_LABEL, istMahnung, mahnLabel, istGuthaben, guthabenLabel } from '../lib/rechnungen/sichtbarkeit';
import { zustaendigLabel } from '../lib/rechnungen/zustaendigkeit';
import { klaerungDefaultIso, KLAERUNG_PRESETS, formatBis } from '../lib/rechnungen/klaerung';
import { sortiereHaeuser } from '../lib/objekte/haeuser';
import { MAIL_FORM_META } from './island/form/mailMeta';

interface Objekt {
  id: string;
  bezeichnung: string;
  strasse: string;
  hausnummer: string;
  plz: string;
  stadt: string;
  objektnummer?: string;
}

interface Eigentuemer {
  id: string;
  anrede?: string | null;
  vorname: string;
  nachname: string;
  firma_name?: string | null;
}

interface Team {
  id: string;
  name: string;
}

interface TeamMember {
  id: string;
  full_name: string;
}

interface RechnungDetailsSidebarProps {
  rechnung: Rechnung | null;
  onClose: () => void;
  onRefresh?: () => void;
  onObjectClick?: (id: string) => void;
  userProfile?: any;
}

const RechnungDetailsSidebar: React.FC<RechnungDetailsSidebarProps> = ({ rechnung, onClose, onRefresh, onObjectClick, userProfile }) => {
  const { openForm, closeForm } = useIslandActions();
  // Edit mode
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Assignment data
  const [objekte, setObjekte] = useState<Objekt[]>([]);
  const [eigentuemer, setEigentuemer] = useState<Eigentuemer[]>([]);
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [teams, setTeams] = useState<Team[]>([]);

  const [objektSearch, setObjektSearch] = useState('');
  const [ownerSearch, setOwnerSearch] = useState('');
  const [selectedObjektId, setSelectedObjektId] = useState<string | null>(null);
  const [selectedEinheitId, setSelectedEinheitId] = useState<string | null>(null);
  // Optionale Haus-Ebene: nur belegt, wenn die Liegenschaft Haeuser hat.
  const [selectedHausId, setSelectedHausId] = useState<string | null>(null);
  const [haeuser, setHaeuser] = useState<{ id: string; bezeichnung: string }[]>([]);
  const [einheiten, setEinheiten] = useState<{ id: string; bezeichnung: string }[]>([]);
  const [selectedOwnerId, setSelectedOwnerId] = useState<string | null>(null);
  const [selectedZustaendigId, setSelectedZustaendigId] = useState<string | null>(null);
  const [selectedZustaendigTyp, setSelectedZustaendigTyp] = useState<'mitarbeiter' | 'team' | null>(null);
  const [notizen, setNotizen] = useState('');
  const [richtung, setRichtung] = useState<'eingang' | 'ausgang' | ''>('');
  const [firmaInput, setFirmaInput] = useState('');
  const [betragInput, setBetragInput] = useState('');
  const [nettoInput, setNettoInput] = useState('');
  const [steuerInput, setSteuerInput] = useState('');
  const [steuersatzInput, setSteuersatzInput] = useState('');

  const [showObjDropdown, setShowObjDropdown] = useState(false);
  const [showOwnerDropdown, setShowOwnerDropdown] = useState(false);
  const [showAssigneeDropdown, setShowAssigneeDropdown] = useState(false);

  const objRef = useRef<HTMLDivElement>(null);
  const ownerRef = useRef<HTMLDivElement>(null);
  const assigneeRef = useRef<HTMLDivElement>(null);

  // Modals
  const [paymentQRVisible, setPaymentQRVisible] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [showDokumentPreview, setShowDokumentPreview] = useState(false);

  // Timeline
  const [timeline, setTimeline] = useState<TimelineEvent[]>([]);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [sendingComment, setSendingComment] = useState(false);

  // Workflow modals
  const [showTechPruefungModal, setShowTechPruefungModal] = useState(false);
  const [showFreigabeModal, setShowFreigabeModal] = useState(false);
  const [selectedPrueferId, setSelectedPrueferId] = useState<string | null>(null);
  const [selectedFreigeberId, setSelectedFreigeberId] = useState<string | null>(null);
  const [workflowLoading, setWorkflowLoading] = useState(false);
  const [techKommentar, setTechKommentar] = useState('');
  const [korrekturOffen, setKorrekturOffen] = useState(false);
  const [korrekturPartner, setKorrekturPartner] = useState<{ nachfolger: KurzRechnung | null; vorgaenger: KurzRechnung | null }>({ nachfolger: null, vorgaenger: null });
  const [verknuepfenOffen, setVerknuepfenOffen] = useState(false);
  const navigate = useNavigate();
  const { mobil } = useMobilModus();
  const { melde, bestaetige, dialoge } = useAppMeldungen(mobil);
  // Zwei Spalten ab 1180 px Fensterbreite (Handoff §5, wie Tickets), darunter eine Spalte
  const zweispaltig = useViewport().width >= 1180;

  useEffect(() => {
    if (!rechnung || rechnung.is_unklar_source) { setKorrekturPartner({ nachfolger: null, vorgaenger: null }); return; }
    let aktiv = true;
    ladeKorrekturPartner(rechnung).then((p) => { if (aktiv) setKorrekturPartner(p); });
    return () => { aktiv = false; };
  }, [rechnung?.id, rechnung?.korrigiert_durch_id]);

  useEffect(() => {
    if (rechnung) {
      setIsEditing(false);
      setShowDokumentPreview(false);
      setSelectedObjektId(rechnung.objekt_id || null);
      setSelectedEinheitId(rechnung.einheit_id || null);
      setSelectedHausId((rechnung as any).haus_id || null);
      setFirmaInput(rechnung.unternehmen && rechnung.unternehmen !== 'KI-ERKENNUNG LÄUFT' ? rechnung.unternehmen : '');
      setSelectedOwnerId(rechnung.eigentuemer_id || null);
      setSelectedZustaendigId(rechnung.zustaendig_id || null);
      setSelectedZustaendigTyp((rechnung.zustaendig_typ as 'mitarbeiter' | 'team' | null) || null);
      setRichtung((rechnung.richtung as 'eingang' | 'ausgang' | undefined) || '');
      setObjektSearch(rechnung.objekt_adresse || '');
      setNotizen(rechnung.notizen || '');
      setBetragInput(rechnung.brutto != null ? rechnung.brutto.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }) : '');
      setNettoInput(rechnung.netto != null ? rechnung.netto.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }) : '');
      setSteuerInput(rechnung.steuer != null ? rechnung.steuer.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }) : '');
      setSteuersatzInput(rechnung.steuersatz != null ? String(rechnung.steuersatz) : '');
      fetchAssignmentData();
    }
  }, [rechnung]);

  // Suchlisten in Bearbeiten: Klick daneben oder Esc schließt sie (vorher nur nach einer Auswahl).
  useEffect(() => {
    const aussen = (e: MouseEvent) => {
      const ziel = e.target as Node;
      if (objRef.current && !objRef.current.contains(ziel)) setShowObjDropdown(false);
      if (ownerRef.current && !ownerRef.current.contains(ziel)) setShowOwnerDropdown(false);
      if (assigneeRef.current && !assigneeRef.current.contains(ziel)) setShowAssigneeDropdown(false);
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || document.querySelector('[aria-modal="true"]')) return;
      setShowObjDropdown(false); setShowOwnerDropdown(false); setShowAssigneeDropdown(false);
    };
    document.addEventListener('mousedown', aussen);
    window.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', aussen); window.removeEventListener('keydown', esc); };
  }, []);

  // Eigene Seite: beim Öffnen (auch Sprung zur Korrektur-Partnerin) oben beginnen
  useEffect(() => { window.scrollTo(0, 0); }, [rechnung?.id]);

  useEffect(() => {
    if (rechnung && !rechnung.is_unklar_source) {
      loadTimeline();
    }
  }, [rechnung?.id]);

  // Einheiten des aktuell gewählten Objekts laden (für Einheit-Zuordnung)
  useEffect(() => {
    if (!selectedObjektId) { setEinheiten([]); return; }
    let aktiv = true;
    supabase
      .from('objekt_einheiten')
      .select('id, bezeichnung')
      .eq('objekt_id', selectedObjektId)
      .order('bezeichnung')
      .then(({ data }) => { if (aktiv) setEinheiten(data || []); });
    return () => { aktiv = false; };
  }, [selectedObjektId]);

  // Häuser des gewählten Objekts (leer = Liegenschaft ohne Haus-Ebene)
  useEffect(() => {
    if (!selectedObjektId) { setHaeuser([]); return; }
    let aktiv = true;
    supabase
      .from('objekt_haeuser')
      .select('id, bezeichnung, sortierung')
      .eq('objekt_id', selectedObjektId)
      .then(({ data }) => {
        if (aktiv) setHaeuser(sortiereHaeuser((data as any[]) || []).map((h) => ({ id: h.id, bezeichnung: h.bezeichnung })));
      });
    return () => { aktiv = false; };
  }, [selectedObjektId]);

  const loadTimeline = async () => {
    if (!rechnung) return;
    setLoadingTimeline(true);
    try {
      const events = await fetchTimeline(rechnung.id);
      setTimeline(events);
    } catch (err) {
      console.error('Timeline laden fehlgeschlagen:', err);
    } finally {
      setLoadingTimeline(false);
    }
  };

  const fetchAssignmentData = async () => {
    try {
      const [objs, owners, mitglieder, teamRows] = await Promise.all([
        supabase.from('objekte').select('id, bezeichnung, strasse, hausnummer, plz, stadt, objektnummer'),
        supabase.from('eigentuemer').select('id, anrede, vorname, nachname, firma_name'),
        supabase.from('profiles').select('id, full_name').or('role.eq.team,role.eq.admin').eq('zuweisbar', true),
        supabase.from('teams').select('id, name').order('name')
      ]);
      setObjekte(objs.data || []);
      setEigentuemer(owners.data || []);
      setTeamMembers(mitglieder.data || []);
      setTeams(teamRows.data || []);

      if (rechnung?.eigentuemer_id) {
        const owner = (owners.data || []).find(o => o.id === rechnung.eigentuemer_id);
        if (owner) setOwnerSearch(eigentuemerAnzeigename(owner));
      } else {
        setOwnerSearch('');
      }

      if (rechnung?.objekt_id) {
        const obj = (objs.data || []).find(o => o.id === rechnung.objekt_id);
        if (obj) setObjektSearch(obj.bezeichnung);
      }
    } catch (err) { console.error(err); }
  };

  const workflowState: WorkflowState | null = rechnung
    ? getWorkflowState(rechnung)
    : null;

  const startEditing = () => {
    setIsEditing(true);
  };

  const handleArchivToggle = async () => {
    if (!rechnung) return;
    setIsSaving(true);
    try {
      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
      const neuerWert = rechnung.archiviert_am ? null : new Date().toISOString();
      const { error } = await supabase.from(targetTable).update({ archiviert_am: neuerWert }).eq('id', rechnung.id);
      if (error) throw error;
      if (onRefresh) onRefresh();
    } catch (err: any) {
      // Seit archivierte Belege beim Import nicht mehr als Duplikat zaehlen, darf derselbe
      // Beleg neu eingehen — das Wiederherstellen der archivierten Fassung ist dann ein 23505.
      melde('Fehler beim Archivieren: ' + (korrekturFehlerText(err) || err?.message || 'Unbekannter Fehler'), true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleSave = async () => {
    if (!rechnung) return;
    setIsSaving(true);
    try {
      // Zuweisung geändert? → Timeline-Event (id ODER Typ)
      const zustChanged = selectedZustaendigId !== rechnung.zustaendig_id
        || selectedZustaendigTyp !== ((rechnung.zustaendig_typ as 'mitarbeiter' | 'team' | null) || null);
      if (zustChanged && userProfile?.id && !rechnung.is_unklar_source) {
        const neuerName = zustaendigLabel(selectedZustaendigId, selectedZustaendigTyp, teamMembers, teams);
        await changeZuweisung(rechnung.id, userProfile.id, selectedZustaendigId, neuerName, selectedZustaendigTyp);
      }

      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
      const updateFields: Record<string, unknown> = {
        objekt_id: selectedObjektId,
        objekt_adresse: objektSearch,
        eigentuemer_id: selectedOwnerId,
        // Haus nur speichern, wenn es zur gewählten Liegenschaft gehört —
        // sonst weist der DB-Trigger die Paarung zurück.
        haus_id: selectedHausId && haeuser.some(h => h.id === selectedHausId) ? selectedHausId : null,
        notizen: notizen,
        unternehmen: firmaInput.trim() || null,
      };
      // Richtung + Beträge nur auf der Hauptliste setzen (rechnungen_unklar hat andere Spalten)
      if (!rechnung.is_unklar_source) {
        // Einheit-Zuordnung nur speichern, wenn sie zum gewählten Objekt gehört
        updateFields.einheit_id = selectedEinheitId && einheiten.some(e => e.id === selectedEinheitId)
          ? selectedEinheitId
          : null;
        updateFields.richtung = richtung === '' ? null : richtung;
        const b = parseBetrag(betragInput);
        if (b !== null) updateFields.brutto = b;
        updateFields.netto = parseBetrag(nettoInput);
        updateFields.steuer = parseBetrag(steuerInput);
        updateFields.steuersatz = String(steuersatzInput).trim() || null;
      }
      // Only update zustaendig_id/typ if it wasn't already handled by changeZuweisung
      if (!zustChanged || rechnung.is_unklar_source) {
        updateFields.zustaendig_id = selectedZustaendigId;
        updateFields.zustaendig_typ = selectedZustaendigTyp;
      }

      const { error } = await supabase
        .from(targetTable)
        .update(updateFields)
        .eq('id', rechnung.id);

      if (error) throw error;
      setIsEditing(false);
      if (onRefresh) onRefresh();
      if (!rechnung.is_unklar_source) await loadTimeline();
    } catch (err: any) {
      // Der Lieferantenname ist seit der Korrektur-Migration Teil des Unique-Schluessels:
      // zwei Schreibweisen desselben Lieferanten zusammenzufuehren kann kollidieren.
      melde('Fehler beim Speichern: ' + (korrekturFehlerText(err) || err.message), true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleStatusUpdate = async (newStatus: string) => {
    if (!rechnung) return;
    setIsSaving(true);
    try {
      if (newStatus.toLowerCase() === 'bezahlt') {
        await handleBezahlt();
      } else {
        const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
        // bezahlt_timestamp existiert nur in rechnungen, nicht in rechnungen_unklar
        const updateData: { status: string; bezahlt_timestamp?: null; klaerung_wiedervorlage_am: string | null } = {
          status: newStatus,
          // Klärungs-Wiedervorlage: beim Setzen auf Klärung Default jetzt+7 Tage,
          // beim Verlassen des Status nullen (Spec 2026-07-28).
          klaerung_wiedervorlage_am: newStatus.toLowerCase() === 'klaerung' ? klaerungDefaultIso(new Date()) : null,
        };
        if (!rechnung.is_unklar_source) updateData.bezahlt_timestamp = null;

        const { error } = await supabase.from(targetTable).update(updateData).eq('id', rechnung.id);
        if (error) throw error;

        if (userProfile?.id && !rechnung.is_unklar_source) {
          await addTimelineEvent(rechnung.id, 'status_aenderung', userProfile.id, `Status geändert zu: ${newStatus}`);
        }
        if (onRefresh) onRefresh();
        if (!rechnung.is_unklar_source) await loadTimeline();
      }
    } catch (err: any) {
      melde(err.message, true);
    } finally {
      setIsSaving(false);
    }
  };

  // Wiedervorlage-Datum einer Klärungs-Rechnung setzen (Preset in Tagen oder konkretes Datum).
  const setzeKlaerungWiedervorlage = async (tage: number) => {
    const iso = new Date(Date.now() + tage * 24 * 60 * 60 * 1000).toISOString();
    await schreibeKlaerungWiedervorlage(iso);
  };
  const setzeKlaerungWiedervorlageDatum = async (datum: string) => {
    await schreibeKlaerungWiedervorlage(new Date(`${datum}T09:00:00`).toISOString());
  };
  const schreibeKlaerungWiedervorlage = async (iso: string) => {
    if (!rechnung) return;
    setIsSaving(true);
    try {
      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
      const { error } = await supabase.from(targetTable).update({ klaerung_wiedervorlage_am: iso }).eq('id', rechnung.id);
      if (error) throw error;
      if (onRefresh) onRefresh();
    } catch (err: any) {
      melde(`Wiedervorlage fehlgeschlagen: ${err.message}`, true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleZustaendigDirect = async (newId: string | null, newTyp: 'mitarbeiter' | 'team' | null) => {
    if (!rechnung) return;
    setIsSaving(true);
    try {
      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
      const { error } = await supabase.from(targetTable).update({ zustaendig_id: newId, zustaendig_typ: newTyp }).eq('id', rechnung.id);
      if (error) throw error;
      setSelectedZustaendigId(newId);
      setSelectedZustaendigTyp(newTyp);
      if (userProfile?.id && !rechnung.is_unklar_source) {
        await addTimelineEvent(rechnung.id, 'zuweisung', userProfile.id, `Zuständigkeit: ${zustaendigLabel(newId, newTyp, teamMembers, teams)}`);
      }
      if (onRefresh) onRefresh();
      if (!rechnung.is_unklar_source) await loadTimeline();
    } catch (err: any) {
      melde('Fehler bei der Zuweisung: ' + err.message, true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleNotizSave = async () => {
    if (!rechnung) return;
    if ((notizen || '') === (rechnung.notizen || '')) return; // nichts geändert
    setIsSaving(true);
    try {
      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';
      const { error } = await supabase.from(targetTable).update({ notizen: notizen || null }).eq('id', rechnung.id);
      if (error) throw error;
      if (onRefresh) onRefresh();
    } catch (err: any) {
      melde('Fehler beim Speichern der Notiz: ' + err.message, true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleTechPruefungSenden = async () => {
    if (!rechnung || !userProfile?.id || !selectedPrueferId) return;
    setWorkflowLoading(true);
    try {
      const pruefer = teamMembers.find(t => t.id === selectedPrueferId);
      await requestTechPruefung(rechnung.id, userProfile.id, selectedPrueferId, pruefer?.full_name || '');
      setShowTechPruefungModal(false);
      setSelectedPrueferId(null);
      if (onRefresh) onRefresh();
      await loadTimeline();
    } catch (err: any) {
      melde('Fehler: ' + err.message, true);
    } finally {
      setWorkflowLoading(false);
    }
  };

  const handleTechPruefungAntwort = async (ergebnis: 'freigegeben' | 'abgelehnt') => {
    if (!rechnung || !userProfile?.id) return;
    setWorkflowLoading(true);
    try {
      await respondTechPruefung(rechnung.id, userProfile.id, ergebnis, techKommentar || undefined);
      setTechKommentar('');
      if (onRefresh) onRefresh();
      await loadTimeline();
    } catch (err: any) {
      melde('Fehler: ' + err.message, true);
    } finally {
      setWorkflowLoading(false);
    }
  };

  const handleFreigabeSenden = async () => {
    if (!rechnung || !userProfile?.id || !selectedFreigeberId) return;
    setWorkflowLoading(true);
    try {
      const freigeber = teamMembers.find(t => t.id === selectedFreigeberId);
      await requestFreigabe(rechnung.id, userProfile.id, selectedFreigeberId, freigeber?.full_name || '');
      setShowFreigabeModal(false);
      setSelectedFreigeberId(null);
      if (onRefresh) onRefresh();
      await loadTimeline();
    } catch (err: any) {
      melde('Fehler: ' + err.message, true);
    } finally {
      setWorkflowLoading(false);
    }
  };

  const handleFreigabeAntwort = async (ergebnis: 'freigegeben' | 'abgelehnt') => {
    if (!rechnung || !userProfile?.id) return;
    setWorkflowLoading(true);
    try {
      await respondFreigabe(rechnung.id, userProfile.id, ergebnis);
      if (onRefresh) onRefresh();
      await loadTimeline();
    } catch (err: any) {
      melde('Fehler: ' + err.message, true);
    } finally {
      setWorkflowLoading(false);
    }
  };

  const handleBezahlt = async (): Promise<boolean> => {
    if (!rechnung || !userProfile?.id) return false;
    setWorkflowLoading(true);
    try {
      if (rechnung.is_unklar_source) {
        // KI-Pool-Eintrag: nur status updaten. rechnungen_unklar hat keine
        // bezahlt_timestamp/bezahlt_von-Spalten und keinen Workflow/Timeline/4-Augen-Pfad.
        // klaerung_wiedervorlage_am nullen (Spec 2026-07-28) — Verlassen des Klärungs-Status.
        const { error } = await supabase
          .from('rechnungen_unklar')
          .update({ status: 'bezahlt', klaerung_wiedervorlage_am: null })
          .eq('id', rechnung.id);
        if (error) throw error;
      } else {
        await markAsBezahlt(rechnung.id, userProfile.id, rechnung.brutto, rechnung.freigegeben || false, userProfile.role);
      }
      if (onRefresh) onRefresh();
      if (!rechnung.is_unklar_source) await loadTimeline();
      return true;
    } catch (err: any) {
      melde(err.message, true);
      return false;
    } finally {
      setWorkflowLoading(false);
    }
  };

  // An Eigentümer weiterleiten: OHNE Seitenwechsel — Detailseite bleibt offen, das
  // Verfassen-Formular öffnet direkt in der Pille (Vorlage automatisch, PDF im Anhang).
  const handleWeiterleitenAnEigentuemer = async () => {
    if (!rechnung) return;
    const ausPool = !!rechnung.is_unklar_source;
    setWorkflowLoading(true);
    try {
      // Aktives E-Mail-Postfach (Standard bevorzugt)
      const { data: konten } = await supabase
        .from('email_konten').select('id, email_adresse, bezeichnung, absender_name')
        .eq('aktiv', true).order('ist_standard', { ascending: false }).limit(1);
      const konto = konten?.[0];
      if (!konto) { melde('Kein aktives E-Mail-Postfach gefunden.', true); return; }
      const kontoName = konto.bezeichnung || konto.absender_name || konto.email_adresse;

      const res = await baueWeiterleitungCompose(rechnung.id, ausPool);
      if (!res.ok) { melde(res.text, true); return; }

      // Pille SOFORT öffnen; die Rechnungs-PDF lädt EmailVerfassen im Hintergrund (autoAnhang).
      openForm(
        <EmailVerfassen
          variant="pille"
          konto={{ id: konto.id, email_adresse: konto.email_adresse, bezeichnung: kontoName }}
          autoVorlageTrigger="rechnung_weiterleitung"
          autoAnhang={{ fileId: res.driveFileId, name: res.dateiname, mimeType: 'application/pdf' }}
          draft={{ an: [res.ownerEmail], betreff: '', text_inhalt: '' }}
          onClose={() => closeForm()}
          onSent={async () => {
            closeForm();
            try {
              await markiereWeitergeleitet({
                rechnungId: res.rechnungId, rechnungsnummer: res.rechnungsnummer,
                ownerId: res.ownerId, ownerEmail: res.ownerEmail, userId: userProfile?.id, ausPool,
              });
            } catch (e) { console.warn('Weiterleitung markieren fehlgeschlagen', e); }
            onRefresh?.();
          }}
        />,
        'Rechnung an Eigentümer',
        640, MAIL_FORM_META,
      );
    } finally {
      setWorkflowLoading(false);
    }
  };

  // Korrektur beim Lieferanten anfordern — derselbe Weg wie die ET-Weiterleitung:
  // Grund erfassen, Verfassen-Pille öffnen, nach dem Versand die Rechnung markieren.
  const handleKorrekturAnfordern = async (grund: string) => {
    if (!rechnung) return;
    setKorrekturOffen(false);
    setWorkflowLoading(true);
    try {
      const { data: konten } = await supabase
        .from('email_konten').select('id, email_adresse, bezeichnung, absender_name')
        .eq('aktiv', true).order('ist_standard', { ascending: false }).limit(1);
      const konto = konten?.[0];
      if (!konto) { melde('Kein aktives E-Mail-Postfach gefunden.', true); return; }
      const kontoName = konto.bezeichnung || konto.absender_name || konto.email_adresse;

      const res = await baueKorrekturCompose(rechnung.id, !!rechnung.is_unklar_source);
      if (!res.ok) { melde(res.text, true); return; }
      // Ohne Eigentuemer traegt die Anschrift in der Mail keinen Namen (Ticket #423) —
      // das soll niemand erst im Postausgang merken.
      if (!res.hatEigentuemer && !(await bestaetige({
        nachricht: 'Trotzdem fortfahren?\n\nDieser Rechnung ist kein Eigentümer zugewiesen. In der Mail steht dann nur die Anschrift '
          + 'der Verwaltung ohne Namen des Rechnungsempfängers.',
        label: 'Fortfahren', icon: WarningCircle, gefahr: false,
      }))) return;

      openForm(
        <EmailVerfassen
          variant="pille"
          konto={{ id: konto.id, email_adresse: konto.email_adresse, bezeichnung: kontoName }}
          autoVorlageTrigger="rechnung_korrektur"
          autoVorlageWerte={{ ...res.vorlagenWerte, 'rechnung.korrektur_grund': grund }}
          autoAnhang={{ fileId: res.driveFileId, name: res.dateiname, mimeType: 'application/pdf' }}
          draft={{ an: res.empfaenger ? [res.empfaenger] : [], betreff: '', text_inhalt: '' }}
          onClose={() => closeForm()}
          onSent={async (info) => {
            closeForm();
            try {
              await markiereKorrekturAngefordert({
                rechnungId: res.rechnungId,
                ausPool: !!rechnung.is_unklar_source,
                grund,
                // Tatsächlich verschickte Adresse bevorzugen: der Nutzer kann sie in der
                // Pille geändert haben, und im Protokoll soll stehen, wohin es ging.
                empfaenger: info?.an?.[0] || res.empfaenger || 'unbekannt',
                userId: userProfile?.id,
              });
            } catch (e) { console.warn('Korrektur markieren fehlgeschlagen', e); }
            onRefresh?.();
          }}
        />,
        'Korrektur anfordern',
        640, MAIL_FORM_META,
      );
    } finally {
      setWorkflowLoading(false);
    }
  };

  // Von Hand zugeordnet, wenn die automatische Zuordnung (Sync) nicht angeschlagen hat.
  const handleVerknuepfungWaehlen = async (nachfolgerId: string) => {
    if (!rechnung) return;
    setVerknuepfenOffen(false);
    try {
      await verknuepfeKorrektur(rechnung.id, nachfolgerId, userProfile?.id);
      onRefresh?.();
    } catch (e: any) { melde('Zuordnen fehlgeschlagen: ' + e.message, true); }
  };

  // K2-Gegenstueck zur Anforderung: ohne diesen Weg bliebe der Beleg fuer immer aus
  // beiden Teil-Indizes ausgenommen, wenn die Korrektur nie eintrifft.
  const handleKorrekturZurueckziehen = async () => {
    if (!rechnung || !(await bestaetige({
      nachricht: 'Angeforderte Korrektur zurückziehen?\n\nDie Rechnungsnummer zählt danach wieder als vergeben.',
      label: 'Zurückziehen', icon: ArrowCounterClockwise,
    }))) return;
    try {
      await ziehKorrekturAnforderungZurueck(rechnung.id, userProfile?.id, !!rechnung.is_unklar_source);
      onRefresh?.();
      await loadTimeline();
    } catch (e: any) {
      melde(korrekturFehlerText(e) || ('Zurückziehen fehlgeschlagen: ' + e.message), true);
    }
  };

  const handleVerknuepfungLoesen = async () => {
    if (!rechnung || !(await bestaetige({ nachricht: 'Verknüpfung zur korrigierten Rechnung lösen?', label: 'Lösen', icon: LinkIcon }))) return;
    try {
      await loeseKorrekturVerknuepfung(rechnung.id);
      onRefresh?.();
    } catch (e: any) { melde('Lösen fehlgeschlagen: ' + e.message, true); }
  };

  const handleAddComment = async () => {
    if (!rechnung || !userProfile?.id || !newComment.trim()) return;
    setSendingComment(true);
    try {
      await addKommentar(rechnung.id, userProfile.id, newComment.trim());
      setNewComment('');
      await loadTimeline();
    } catch (err: any) {
      melde('Kommentar fehlgeschlagen: ' + err.message, true);
    } finally {
      setSendingComment(false);
    }
  };

  const confirmDelete = async () => {
    if (!rechnung) return;
    setIsDeleting(true);
    try {
      const targetTable = rechnung.is_unklar_source ? 'rechnungen_unklar' : 'rechnungen';

      // 1. Timeline-Einträge zuerst entfernen (FK-Schutz, falls kein CASCADE gesetzt)
      if (!rechnung.is_unklar_source) {
        const { error: timelineErr } = await supabase
          .from('rechnungen_timeline')
          .delete()
          .eq('rechnung_id', rechnung.id);
        if (timelineErr) {
          console.warn('Timeline-Cleanup fehlgeschlagen:', timelineErr);
        }
      }

      // 2. DB-Delete mit .select() — erkennt RLS-stilles Fehlschlagen (0 Rows ohne Error)
      const { data: deletedRows, error } = await supabase
        .from(targetTable)
        .delete()
        .eq('id', rechnung.id)
        .select('id');
      if (error) throw error;
      if (!deletedRows || deletedRows.length === 0) {
        throw new Error('Beleg konnte nicht gelöscht werden — vermutlich fehlende Berechtigung (RLS-Policy prüfen).');
      }

      if (onRefresh) onRefresh();
      onClose();
    } catch (err: any) {
      melde('Löschen fehlgeschlagen: ' + (err?.message || 'Unbekannter Fehler'), true);
    } finally {
      setIsDeleting(false);
      setShowDeleteConfirm(false);
    }
  };

  const generatePDF = () => {
    if (!rechnung) return;
    setIsGeneratingPdf(true);
    try {
      exportSingleRechnungPdf(rechnung, timeline);
    } catch (err) {
      melde("PDF-Erstellung fehlgeschlagen.", true);
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    melde('Kopiert');
  };

  // Helpers
  const isPaid = rechnung?.status?.toLowerCase() === 'bezahlt';
  const driveFileId = getDriveFileId(rechnung?.datei_url);
  const currentAssigneeName = zustaendigLabel(selectedZustaendigId, selectedZustaendigTyp, teamMembers, teams);
  const currentOwnerName = eigentuemer.find(e => e.id === selectedOwnerId);
  const currentObjekt = objekte.find(o => o.id === selectedObjektId);
  const matchedObjekt = (rechnung as any)?._matchedObjektId
    ? objekte.find(o => o.id === (rechnung as any)._matchedObjektId)
    : null;

  const filteredObjs = objekte.filter(o =>
    (o.bezeichnung || '').toLowerCase().includes(objektSearch.toLowerCase()) ||
    (o.strasse || '').toLowerCase().includes(objektSearch.toLowerCase())
  );
  const filteredOwners = eigentuemer.filter(e =>
    `${eigentuemerAnzeigename(e)} ${e.vorname || ''} ${e.nachname || ''} ${e.firma_name || ''}`
      .toLowerCase().includes(ownerSearch.toLowerCase())
  );

  if (!rechnung) return null;

  const pool = !!rechnung.is_unklar_source;
  const istKlaerung = rechnung.status?.toLowerCase() === 'klaerung';
  // Fälligkeits-Hinweis wie in der Liste (Entscheidung 17.10.2026)
  const faelligBadge = getFaelligkeitsBadge(rechnung.faelligkeitsdatum, rechnung.status);
  const ton = statusTon(rechnung.status);
  // Status-Chip im Kopf und am Betrag: „Klärungsbedarf · bis TT.MM.“ bzw. deutsches Label
  const statusTextDetail = (istKlaerung ? 'Klärungsbedarf' : statusLabelDe((rechnung.status || 'offen').toLowerCase()))
    + (istKlaerung && rechnung.klaerung_wiedervorlage_am ? ` · ${formatBis(rechnung.klaerung_wiedervorlage_am)}` : '');
  const weiterleitenLabel = rechnung.weitergeleitet_am
    ? `Weitergeleitet · ${new Date(rechnung.weitergeleitet_am).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })}`
    : 'An Eigentümer senden';
  const statusKnopf = { height: 44, gap: 6, borderRadius: 14, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 700 } as const;
  const antwortKnopf = { height: 42, gap: 6, borderRadius: 13, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 800 } as const;
  const korrKnopf = { minHeight: mobil ? 44 : 38, padding: '0 12px', gap: 6, borderRadius: 12, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700 } as const;
  const zuwKachel = { gap: 10, padding: '10px 12px', borderRadius: 16, border: 'none', fontFamily: 'inherit', color: 'var(--ink)', background: 'var(--fill)' } as const;
  const zuwLabel = { fontSize: 11.5, fontWeight: 700, color: 'var(--ink3)' } as const;
  const zuwWert = { fontSize: 13.5, fontWeight: 800 } as const;

  return (
    <div className="flex flex-col" style={{ gap: 14 }}>
      {/* Kopf-Widget: Zurück, Chips, Firma, Nummer, Werkzeugleiste */}
      <section className="immo-glas immo-side-in flex flex-col" style={{ borderRadius: 28, padding: '16px 18px', gap: 12 }}>
        <div className="flex flex-wrap items-center" style={{ gap: 8 }}>
          <button type="button" onClick={onClose} data-tip="Zurück zur Liste" className="inline-flex items-center"
            style={{ height: mobil ? 44 : 34, padding: '0 13px 0 9px', gap: 5, borderRadius: 17, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
              fontSize: 13, fontWeight: 700, background: 'var(--fill2)', color: 'var(--ink)' }}>
            <CaretLeft size={13} weight="bold" />Alle Rechnungen
          </button>
          <DetailChip label={statusTextDetail} icon={Circle} farbe={ton.farbe} flaeche={ton.flaeche} />
          <DetailChip label={pool ? 'KI-Pool' : 'Rechnung'} icon={pool ? Sparkle : Receipt} farbe={pool ? 'var(--pur)' : 'var(--ink2)'} flaeche={pool ? 'var(--pur-soft)' : 'var(--fill2)'} />
          {istGuthaben(rechnung) && <DetailChip label={guthabenLabel(rechnung) || ''} icon={HandCoins} farbe="var(--ok)" flaeche="var(--ok-soft)" />}
          {istMahnung(rechnung) && <DetailChip label={mahnLabel(rechnung) || ''} icon={WarningCircle} farbe="#e8730c" flaeche="rgba(232,115,12,0.14)" />}
          {rechnung.archiviert_am && <DetailChip label="Archiviert" icon={Archive} farbe="var(--ink2)" flaeche="var(--fill3)" />}
        </div>
        <div className="flex flex-wrap items-center" style={{ gap: 14 }}>
          <span aria-hidden className="inline-flex shrink-0 items-center justify-center"
            style={{ width: 54, height: 54, borderRadius: 17, background: pool ? 'var(--pur)' : 'var(--acc-fill)', color: pool ? '#fff' : 'var(--acc-ink)', boxShadow: '0 12px 24px -12px var(--shade)' }}>
            {pool ? <Sparkle size={26} weight="fill" /> : <Receipt size={26} weight="fill" />}
          </span>
          <div className="flex min-w-0 flex-col" style={{ flex: '1 1 260px', gap: 2 }}>
            <h1 className="m-0" style={{ fontSize: mobil ? 26 : 34, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.05, overflowWrap: 'anywhere' }}>{rechnung.unternehmen}</h1>
            <span className="flex items-center" style={{ gap: 6, fontSize: 13.5, fontWeight: 700, color: 'var(--ink2)' }}>
              <span className="truncate">#{rechnung.rechnungsnummer}</span>
              <KopierKnopf onClick={() => copyToClipboard(rechnung.rechnungsnummer)} tip="Belegnummer kopieren" />
            </span>
          </div>
          <div role="toolbar" aria-label="Werkzeuge" className="flex flex-wrap items-center" style={{ padding: 4, gap: 2, borderRadius: 20, background: 'var(--fill2)' }}>
            {rechnung.datei_url ? (
              <WerkzeugKnopf icon={Eye} label="Dokument" tip="Dokument – Originalbeleg in neuem Tab öffnen" onClick={() => window.open(rechnung.datei_url, '_blank')} mobil={mobil} />
            ) : (
              <span data-tip="Kein Dokument hinterlegt" className="inline-flex items-center" style={{ height: 36, padding: '0 12px', fontSize: 12.5, fontWeight: 700, color: 'var(--ink3)' }}>— Dokument</span>
            )}
            <WerkzeugKnopf icon={isGeneratingPdf ? CircleNotch : DownloadSimple} laeuft={isGeneratingPdf} label="PDF" tip="PDF – Belegblatt mit Verlauf als PDF erstellen" onClick={generatePDF} mobil={mobil} />
            {!isPaid ? (
              <WerkzeugKnopf icon={QrCode} label="QR-Code" tip="QR-Code – SEPA-Bezahlcode für die Banking-App" onClick={() => setPaymentQRVisible(true)} mobil={mobil} />
            ) : (
              <span className="inline-flex items-center" style={{ height: 36, padding: '0 12px', gap: 6, fontSize: 12.5, fontWeight: 800, color: 'var(--ok)' }}><CheckCircle size={15} weight="fill" />Bezahlt</span>
            )}
            <span aria-hidden style={{ width: 1, alignSelf: 'stretch', margin: '6px 2px', background: 'var(--line)' }} />
            {!isEditing && (
              <WerkzeugKnopf icon={PencilSimple} label="Bearbeiten" akzent tip="Bearbeiten – Firma, Zuweisung, Richtung, Beträge und Notizen ändern" onClick={startEditing} mobil={mobil} />
            )}
            <WerkzeugKnopf icon={rechnung.archiviert_am ? ArrowUUpLeft : Archive} gesperrt={isSaving}
              tip={rechnung.archiviert_am ? 'Aus Archiv wiederherstellen' : 'Archivieren'} onClick={handleArchivToggle} mobil={mobil} />
            <WerkzeugKnopf icon={Trash} gefahr tip="Beleg löschen – unwiderruflich, mit Rückfrage" onClick={() => setShowDeleteConfirm(true)} mobil={mobil} />
          </div>
        </div>
      </section>

      {/* Eigentümerportal (Portale E7): wartet auf / Entscheidung des Eigentümers */}
      {!isEditing && (
        <EigentuemerEntscheidung key={rechnung.id} rechnungId={rechnung.id} userId={userProfile.id} melde={melde} bestaetige={bestaetige}
          onGeaendert={() => { loadTimeline(); onRefresh?.(); }} />
      )}

      {isEditing ? (
        <>
          <div className="grid items-start" style={{ gap: 14, gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 380px), 1fr))' }}>
            <Widget titel="Firma / Absender" icon={Buildings} schlicht>
              <input type="text" value={firmaInput} onChange={(e) => setFirmaInput(e.target.value)} placeholder="Firma / Absender eingeben..." aria-label="Firma / Absender" style={FELD} />
              <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Erscheint als Titel in der Übersicht — auch bei KI-Pool-Belegen.</span>
            </Widget>

            {/* #610: offene Auswahlliste über die Nachbarkarten legen (jede Glas-Karte ist eine eigene Ebene) */}
            <Widget titel="Objekt-Zuweisung" icon={Buildings} schlicht gap={10} style={{ position: 'relative', zIndex: showObjDropdown ? 20 : undefined }}>
              <div className="relative flex flex-col" style={{ gap: 4 }} ref={objRef}>
                <span style={FELD_LABEL}>Objekt</span>
                <div className="flex items-center" style={{ ...FELD, gap: 8, padding: '0 12px' }}>
                  <MagnifyingGlass size={15} color="var(--ink3)" className="shrink-0" />
                  <input type="text" value={objektSearch} onChange={(e) => { setObjektSearch(e.target.value); setShowObjDropdown(true); }}
                    onFocus={() => setShowObjDropdown(true)} placeholder="Objekt suchen..." aria-label="Objekt suchen"
                    className="min-w-0 flex-1" style={{ border: 'none', outline: 'none', background: 'transparent', fontFamily: 'inherit', fontSize: 14, fontWeight: 700, color: 'var(--ink)' }} />
                  {selectedObjektId && <Check size={14} weight="bold" color="var(--ok)" className="shrink-0" />}
                </div>
                {showObjDropdown && (
                  <div role="listbox" aria-label="Objekte" className="immo-pop-in immo-scroll absolute flex flex-col" style={AUSWAHL_LISTE}>
                    {filteredObjs.length > 0 ? filteredObjs.slice(0, 8).map(o => (
                      <button key={o.id} type="button" role="option" aria-selected={selectedObjektId === o.id}
                        onClick={() => { setSelectedObjektId(o.id); setObjektSearch(o.bezeichnung); setShowObjDropdown(false); setSelectedEinheitId(null); setSelectedHausId(null); }}
                        className="immo-zeile-hover flex items-center text-left" style={AUSWAHL_ZEILE}>
                        <Buildings size={14} color="var(--ink3)" className="shrink-0" />
                        <span className="flex min-w-0 flex-col">
                          <span className="truncate" style={{ fontSize: 13, fontWeight: 700 }}>{o.bezeichnung}</span>
                          <span className="truncate" style={{ fontSize: 11.5, color: 'var(--ink3)' }}>{o.strasse} {o.hausnummer}</span>
                        </span>
                      </button>
                    )) : <span style={{ padding: '10px 12px', fontSize: 12.5, color: 'var(--ink3)' }}>Nichts gefunden</span>}
                  </div>
                )}
              </div>
              {/* Haus-Zuordnung — nur bei Liegenschaften mit Häusern */}
              {selectedObjektId && haeuser.length > 0 && (
                <label className="flex flex-col" style={{ gap: 4 }}>
                  <span style={FELD_LABEL}>Haus (optional)</span>
                  <select value={selectedHausId || ''} onChange={(e) => setSelectedHausId(e.target.value || null)} style={{ ...FELD, cursor: 'pointer' }}>
                    <option value="">Keine Zuordnung (ganze Liegenschaft)</option>
                    {haeuser.map(h => <option key={h.id} value={h.id}>{h.bezeichnung}</option>)}
                  </select>
                </label>
              )}
              {/* Einheit-Zuordnung (optional) */}
              {selectedObjektId && einheiten.length > 0 && (
                <label className="flex flex-col" style={{ gap: 4 }}>
                  <span style={FELD_LABEL}>Einheit (optional)</span>
                  <select value={selectedEinheitId || ''} onChange={(e) => setSelectedEinheitId(e.target.value || null)} style={{ ...FELD, cursor: 'pointer' }}>
                    <option value="">Keine Zuordnung (ganzes Objekt)</option>
                    {einheiten.map(e => <option key={e.id} value={e.id}>{e.bezeichnung}</option>)}
                  </select>
                </label>
              )}
            </Widget>

            <Widget titel="Eigentümer-Zuweisung" icon={UserCircle} schlicht style={{ position: 'relative', zIndex: showOwnerDropdown ? 20 : undefined }}>
              <div className="relative flex flex-col" style={{ gap: 4 }} ref={ownerRef}>
                <span style={FELD_LABEL}>Eigentümer</span>
                <div className="flex items-center" style={{ ...FELD, gap: 8, padding: '0 12px' }}>
                  <MagnifyingGlass size={15} color="var(--ink3)" className="shrink-0" />
                  <input type="text" value={ownerSearch} onChange={(e) => { setOwnerSearch(e.target.value); setShowOwnerDropdown(true); }}
                    onFocus={() => setShowOwnerDropdown(true)} placeholder="Eigentümer suchen..." aria-label="Eigentümer suchen"
                    className="min-w-0 flex-1" style={{ border: 'none', outline: 'none', background: 'transparent', fontFamily: 'inherit', fontSize: 14, fontWeight: 700, color: 'var(--ink)' }} />
                  {selectedOwnerId && <Check size={14} weight="bold" color="var(--ok)" className="shrink-0" />}
                </div>
                {showOwnerDropdown && (
                  <div role="listbox" aria-label="Eigentümer" className="immo-pop-in immo-scroll absolute flex flex-col" style={AUSWAHL_LISTE}>
                    {filteredOwners.length > 0 ? filteredOwners.slice(0, 8).map(e => {
                      const zusatz = ansprechpartnerZusatz(e);
                      return (
                        <button key={e.id} type="button" role="option" aria-selected={selectedOwnerId === e.id}
                          onClick={() => { setSelectedOwnerId(e.id); setOwnerSearch(eigentuemerAnzeigename(e)); setShowOwnerDropdown(false); }}
                          className="immo-zeile-hover flex items-center text-left" style={AUSWAHL_ZEILE}>
                          {istFirma(e) ? <Buildings size={15} color="var(--ink3)" className="shrink-0" /> : <UserCircle size={15} color="var(--ink3)" className="shrink-0" />}
                          <span className="flex min-w-0 flex-col">
                            <span className="truncate" style={{ fontSize: 13, fontWeight: 700 }}>{eigentuemerAnzeigename(e)}</span>
                            {zusatz && <span className="truncate" style={{ fontSize: 11.5, color: 'var(--ink3)' }}>{zusatz}</span>}
                          </span>
                        </button>
                      );
                    }) : <span style={{ padding: '10px 12px', fontSize: 12.5, color: 'var(--ink3)' }}>Nichts gefunden</span>}
                  </div>
                )}
              </div>
            </Widget>

            <Widget titel="Zuständigkeit" icon={UserCheck} schlicht style={{ position: 'relative', zIndex: showAssigneeDropdown ? 20 : undefined }}>
              <div className="relative flex flex-col" style={{ gap: 4 }} ref={assigneeRef}>
                <span style={FELD_LABEL}>Zuständig</span>
                <button type="button" onClick={() => setShowAssigneeDropdown(!showAssigneeDropdown)} aria-expanded={showAssigneeDropdown}
                  className="flex items-center text-left" style={{ ...FELD, gap: 8, padding: '0 12px', cursor: 'pointer' }}>
                  <UserCheck size={15} weight="fill" color="var(--acc)" className="shrink-0" />
                  <span className="min-w-0 flex-1 truncate">{currentAssigneeName}</span>
                  <CaretDown size={12} weight="bold" color="var(--ink3)" className="shrink-0" />
                </button>
                {showAssigneeDropdown && (
                  <div role="listbox" aria-label="Zuständig" className="immo-pop-in immo-scroll absolute flex flex-col" style={AUSWAHL_LISTE}>
                    <AuswahlZeile icon={GlobeSimple} label="Global" an={!selectedZustaendigId} onClick={() => { setSelectedZustaendigId(null); setSelectedZustaendigTyp(null); setShowAssigneeDropdown(false); }} />
                    {teamMembers.map(m => (
                      <AuswahlZeile key={m.id} icon={User} label={m.full_name} an={selectedZustaendigTyp !== 'team' && selectedZustaendigId === m.id}
                        onClick={() => { setSelectedZustaendigId(m.id); setSelectedZustaendigTyp('mitarbeiter'); setShowAssigneeDropdown(false); }} />
                    ))}
                    {teams.map(t => (
                      <AuswahlZeile key={t.id} icon={UsersThree} label={t.name} an={selectedZustaendigTyp === 'team' && selectedZustaendigId === t.id}
                        onClick={() => { setSelectedZustaendigId(t.id); setSelectedZustaendigTyp('team'); setShowAssigneeDropdown(false); }} />
                    ))}
                  </div>
                )}
              </div>
            </Widget>

            {!pool && (
              <Widget titel="Richtung" icon={ArrowsLeftRight} schlicht>
                <Segment<'' | 'eingang' | 'ausgang'> ariaLabel="Richtung" art="akzent" voll hoehe={mobil ? 44 : 34} wert={richtung} onChange={setRichtung}
                  eintraege={[{ key: '', label: 'Leer' }, { key: 'eingang', label: 'Eingehend' }, { key: 'ausgang', label: 'Ausgehend' }]} />
              </Widget>
            )}

            {!pool && (
              <Widget titel="Beträge" icon={Bank} schlicht gap={10}>
                <div className="grid" style={{ gap: 8, gridTemplateColumns: '1fr 1fr' }}>
                  <label className="flex min-w-0 flex-col" style={{ gap: 4 }}><span style={FELD_LABEL}>Brutto</span>
                    <input type="text" inputMode="decimal" value={betragInput} onChange={(e) => setBetragInput(e.target.value)} placeholder="0,00" style={{ ...FELD, fontWeight: 800 }} /></label>
                  <label className="flex min-w-0 flex-col" style={{ gap: 4 }}><span style={FELD_LABEL}>Netto</span>
                    <input type="text" inputMode="decimal" value={nettoInput} onChange={(e) => setNettoInput(e.target.value)} placeholder="0,00" style={FELD} /></label>
                  <label className="flex min-w-0 flex-col" style={{ gap: 4 }}><span style={FELD_LABEL}>Steuer</span>
                    <input type="text" inputMode="decimal" value={steuerInput} onChange={(e) => setSteuerInput(e.target.value)} placeholder="0,00" style={FELD} /></label>
                  <label className="flex min-w-0 flex-col" style={{ gap: 4 }}><span style={FELD_LABEL}>Steuersatz</span>
                    <input type="text" value={steuersatzInput} onChange={(e) => setSteuersatzInput(e.target.value)} placeholder="z.B. 19%" style={FELD} /></label>
                </div>
                <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Werte mit Komma eingeben (z.B. 102,01) – zum manuellen Korrigieren von KI-Rundungsfehlern.</span>
              </Widget>
            )}

            {!pool && rechnung.richtung !== 'ausgang' && (
              <Widget titel="§ 35a-Lohnanteil" icon={Bank} schlicht gap={8}>
                <Rechnung35aBox rechnungId={rechnung.id} />
              </Widget>
            )}

            <Widget titel="Notizen" icon={NotePencil} schlicht>
              <textarea value={notizen} onChange={(e) => setNotizen(e.target.value)} rows={4} placeholder="Interne Anmerkungen..." aria-label="Notizen"
                style={{ ...FELD, height: 'auto', padding: '10px 12px', resize: 'vertical', lineHeight: 1.5, fontWeight: 600 }} />
            </Widget>
          </div>

          {/* Untere Leiste — sticky */}
          <div className="immo-glas sticky flex justify-end" style={{ bottom: mobil ? 96 : 14, zIndex: 20, gap: 8, padding: 10, borderRadius: 22,
            boxShadow: 'var(--glass-sh), 0 20px 40px -18px var(--shade)' }}>
            <button type="button" onClick={() => setIsEditing(false)}
              style={{ height: 46, padding: '0 18px', borderRadius: 15, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 700, background: 'var(--fill2)', color: 'var(--ink)' }}>
              Abbrechen
            </button>
            <button type="button" onClick={handleSave} disabled={isSaving} className="inline-flex items-center"
              style={{ height: 46, padding: '0 22px', gap: 7, borderRadius: 15, border: 'none', cursor: isSaving ? 'default' : 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 800,
                background: 'var(--acc-fill)', boxShadow: 'var(--acc-sh)', color: 'var(--acc-ink)' }}>
              {isSaving ? <CircleNotch size={15} weight="bold" className="animate-spin" /> : <FloppyDisk size={15} weight="bold" />}Speichern
            </button>
          </div>
        </>
      ) : (
        <div className="grid items-start" style={{ gap: 14, gridTemplateColumns: zweispaltig ? 'minmax(0,1.45fr) minmax(320px,1fr)' : 'minmax(0,1fr)' }}>
          {/* ── Linke Spalte ── */}
          <div className="flex min-w-0 flex-col" style={{ gap: 14 }}>
            {/* Betrag */}
            <section className="relative flex flex-col overflow-hidden" style={{ gap: 8, padding: '20px 22px', borderRadius: 26, background: 'var(--acc-fill)', boxShadow: 'var(--acc-sh)', color: 'var(--acc-ink)' }}>
              <div className="flex items-center justify-between">
                <span style={{ fontSize: 13, fontWeight: 700, opacity: 0.8 }}>Betrag</span>
                <span className="inline-flex items-center" style={{ height: 26, padding: '0 10px', borderRadius: 13, fontSize: 11.5, fontWeight: 800, background: 'rgba(255,255,255,0.2)' }}>{statusTextDetail}</span>
              </div>
              <div className="flex flex-wrap items-baseline" style={{ gap: 10 }}>
                <span className="tabular-nums" style={{ fontSize: mobil ? 34 : 42, fontWeight: 800, letterSpacing: '-0.04em', lineHeight: 1 }}>
                  {rechnung.brutto != null ? rechnung.brutto.toLocaleString('de-DE', { minimumFractionDigits: 2 }) : '0,00'}
                </span>
                <span style={{ fontSize: 16, fontWeight: 800, opacity: 0.75 }}>{rechnung.waehrung || 'EUR'}</span>
                <span className="self-center"><KopierKnopf hell groesse={32} tip="Betrag kopieren" onClick={() => copyToClipboard(rechnung.brutto.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }))} /></span>
              </div>
            </section>

            {/* Warum liegt der Beleg im Pool? Grund aus den harten Feldern abgeleitet (Ticket #419). */}
            {pool && (
              <div className="flex" style={{ gap: 12, padding: '16px 18px', borderRadius: 22, background: 'var(--pur-soft)' }}>
                <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 36, height: 36, borderRadius: 11, background: 'var(--pur)', color: '#fff' }}><Sparkle size={18} weight="fill" /></span>
                <div className="flex min-w-0 flex-col" style={{ gap: 4 }}>
                  <span style={{ fontSize: 15, fontWeight: 800, color: 'var(--pur)' }}>{poolGrund(rechnung).titel}</span>
                  <span style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--ink2)' }}>{poolGrund(rechnung).text}</span>
                </div>
              </div>
            )}

            {/* Notiz – immer sichtbar, direkt editierbar, speichert beim Verlassen */}
            <Widget gap={8} style={{ padding: '14px 16px' }}>
              <label htmlFor="rechnung-notiz" className="flex items-center" style={{ gap: 8, fontSize: 14, fontWeight: 800 }}>
                <NotePencil size={16} weight="fill" color="var(--acc)" />Notiz
                {isSaving && <CircleNotch size={13} weight="bold" color="var(--ink3)" className="animate-spin" />}
              </label>
              <textarea id="rechnung-notiz" value={notizen} onChange={(e) => setNotizen(e.target.value)} onBlur={handleNotizSave} rows={2}
                placeholder="Notiz hinzufügen… (wird beim Verlassen automatisch gespeichert)"
                style={{ width: '100%', resize: 'vertical', border: 'none', outline: 'none', borderRadius: 14, padding: '10px 12px', background: 'var(--fill)',
                  boxShadow: 'inset 0 0 0 1px var(--line)', fontFamily: 'inherit', fontSize: 14, lineHeight: 1.5, color: 'var(--ink)' }} />
            </Widget>

            {/* Dokumenten-Vorschau (Drive-Embed) */}
            {rechnung.datei_url && (
              <Widget gap={10} style={{ padding: 12 }}>
                {driveFileId ? (
                  <>
                    <button type="button" onClick={() => setShowDokumentPreview(!showDokumentPreview)} aria-expanded={showDokumentPreview}
                      className="inline-flex items-center justify-center"
                      style={{ height: 44, gap: 7, borderRadius: 14, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 800, background: 'var(--fill2)', color: 'var(--ink)' }}>
                      {showDokumentPreview ? <CaretUp size={13} weight="bold" /> : <CaretDown size={13} weight="bold" />}
                      {showDokumentPreview ? 'Vorschau ausblenden' : 'Vorschau anzeigen'}
                    </button>
                    {showDokumentPreview && (
                      <iframe src={`https://drive.google.com/file/d/${driveFileId}/preview`} className="block w-full"
                        style={{ height: 520, border: 'none', borderRadius: 16, background: '#fff', boxShadow: 'inset 0 0 0 1px var(--line)' }}
                        loading="lazy" title="Dokumenten-Vorschau" />
                    )}
                  </>
                ) : (
                  <span className="text-center" style={{ padding: 8, fontSize: 12.5, fontWeight: 700, color: 'var(--ink3)' }}>Vorschau nur für Drive-Dokumente</span>
                )}
              </Widget>
            )}

            {/* Zahlungsdaten */}
            <Widget titel="Zahlungsdaten" icon={Bank} farbe="#34c759" gap={2}>
              <InfoZeile label="Rechnungssteller" wert={rechnung.unternehmen || '-'} onKopieren={() => copyToClipboard(rechnung.unternehmen || '-')} />
              <InfoZeile label="Richtung" wert={
                <span className="inline-flex items-center" style={{ gap: 6 }}>
                  {getRichtung(rechnung) === 'ausgang' ? <ArrowLineUp size={13} weight="bold" color="var(--acc)" /> : <ArrowLineDown size={13} weight="bold" color="var(--acc)" />}
                  {RICHTUNG_LABEL[getRichtung(rechnung)]}
                </span>
              } />
              <InfoZeile label="Beschreibung" wert={rechnung.bezeichnung || 'KI-Analyse läuft...'} onKopieren={() => copyToClipboard(rechnung.bezeichnung || 'KI-Analyse läuft...')} />
              {/* EIN Kopierklick für das Verwendungszweck-Feld der Überweisung (User-Wunsch 2026-07-23). */}
              <InfoZeile label="Verwendungszweck" wert={verwendungszweckAnzeige(rechnung.rechnungsnummer, rechnung.verwendungszweck)}
                onKopieren={() => copyToClipboard(verwendungszweckAnzeige(rechnung.rechnungsnummer, rechnung.verwendungszweck))} />
              <InfoZeile label="IBAN" wert={rechnung.iban || 'Nicht erkannt'} onKopieren={rechnung.iban ? () => copyToClipboard(rechnung.iban!) : undefined} />
              <InfoZeile label="Zahlungsart" wert={rechnung.zahlungsart || '-'} letzte />
              {(!!rechnung.netto || !!rechnung.steuer || rechnung.brutto != null) && (
                <div className="grid" style={{ gap: 8, paddingTop: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
                  {!!rechnung.netto && <BetragKachel label="Netto" wert={`${rechnung.netto.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €`} onKopieren={() => copyToClipboard(rechnung.netto!.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }))} />}
                  {!!rechnung.steuer && <BetragKachel label="MwSt." wert={`${rechnung.steuer.toLocaleString('de-DE', { minimumFractionDigits: 2 })} € (${rechnung.steuersatz || '19%'})`} onKopieren={() => copyToClipboard(rechnung.steuer!.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }))} />}
                  {rechnung.brutto != null && <BetragKachel label="Brutto" wert={`${rechnung.brutto.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €`} onKopieren={() => copyToClipboard(rechnung.brutto.toLocaleString('de-DE', { minimumFractionDigits: 2, useGrouping: false }))} />}
                </div>
              )}
            </Widget>

            {/* Verlauf — Pool-Belege haben keinen */}
            {!pool && (
              <Widget titel={`Verlauf (${timeline.length})`} icon={ClockCounterClockwise} farbe="#8e8e93" gap={12}>
                {loadingTimeline ? (
                  <div className="flex justify-center" style={{ padding: '12px 0' }}><CircleNotch size={18} weight="bold" color="var(--ink3)" className="animate-spin" /></div>
                ) : timeline.length === 0 ? (
                  <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Noch keine Einträge</span>
                ) : (
                  <ol className="immo-scroll m-0 flex list-none flex-col p-0" style={{ maxHeight: 420, overflowY: 'auto' }}>
                    {timeline.map((event) => {
                      const config = TIMELINE_CONFIG[event.typ] || TIMELINE_CONFIG.kommentar;
                      const VI = VERLAUF_ICON[event.typ] || VERLAUF_ICON.kommentar;
                      return (
                        <li key={event.id} className="flex" style={{ gap: 12 }}>
                          <div className="flex flex-col items-center">
                            <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 30, height: 30, borderRadius: '50%', background: config.color, color: '#fff' }}>
                              <VI size={14} weight="fill" />
                            </span>
                            <span aria-hidden style={{ flex: 1, width: 2, minHeight: 10, background: 'var(--line)' }} />
                          </div>
                          <div className="flex min-w-0 flex-1 flex-col" style={{ gap: 2, paddingBottom: 12 }}>
                            <span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--ink3)' }}>
                              {new Date(event.created_at).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })},{' '}
                              {new Date(event.created_at).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}
                              {event.user?.full_name && ` · ${event.user.full_name}`}
                            </span>
                            {event.typ === 'kommentar' ? (
                              <span style={{ marginTop: 2, padding: '8px 12px', borderRadius: 12, background: 'var(--fill)', fontSize: 13.5, lineHeight: 1.45, fontWeight: 600 }}>{event.inhalt}</span>
                            ) : (
                              <span style={{ fontSize: 13.5, lineHeight: 1.45, fontWeight: 600 }}>{event.inhalt || config.label}</span>
                            )}
                          </div>
                        </li>
                      );
                    })}
                  </ol>
                )}
                <div className="flex" style={{ gap: 8 }}>
                  <input value={newComment} onChange={(e) => setNewComment(e.target.value)} aria-label="Kommentar schreiben"
                    onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) handleAddComment(); }} placeholder="Kommentar schreiben..."
                    className="min-w-0 flex-1" style={{ height: 44, padding: '0 14px', borderRadius: 14, border: 'none', outline: 'none', background: 'var(--fill2)', fontFamily: 'inherit', fontSize: 14, fontWeight: 600, color: 'var(--ink)' }} />
                  <button type="button" onClick={handleAddComment} disabled={!newComment.trim() || sendingComment} aria-label="Kommentar senden" data-tip="Kommentar senden (Enter)"
                    className="inline-flex shrink-0 items-center justify-center"
                    style={{ width: 44, height: 44, borderRadius: 14, border: 'none', cursor: 'pointer', background: 'var(--acc-fill)', color: 'var(--acc-ink)', opacity: !newComment.trim() || sendingComment ? 0.45 : 1 }}>
                    {sendingComment ? <CircleNotch size={16} weight="bold" className="animate-spin" /> : <PaperPlaneTilt size={16} weight="fill" />}
                  </button>
                </div>
              </Widget>
            )}
          </div>

          {/* ── Rechte Spalte ── */}
          <div className="flex min-w-0 flex-col" style={{ gap: 14 }}>
            {/* Status ändern */}
            {!isPaid && (
              <Widget titel="Status ändern" icon={Clock} farbe="#0a84ff" gap={10}>
                <div className="grid" style={{ gap: 8, gridTemplateColumns: '1fr 1fr' }}>
                  <button type="button" onClick={() => handleStatusUpdate('bezahlt')} disabled={isSaving} data-tip="Bezahlt – als bezahlt markieren (bei ≥ 3.000 € nur mit Vier-Augen-Freigabe)"
                    className="inline-flex items-center justify-center" style={{ ...statusKnopf, fontWeight: 800, background: '#34c759', color: '#fff', opacity: isSaving ? 0.5 : 1 }}>
                    {isSaving ? <CircleNotch size={15} weight="bold" className="animate-spin" /> : <CheckCircle size={15} weight="bold" />}Bezahlt
                  </button>
                  <button type="button" onClick={() => handleStatusUpdate('unklar')} disabled={isSaving || rechnung.status?.toLowerCase() === 'unklar'} data-tip="Unklar – zurück in die Prüfung"
                    className="inline-flex items-center justify-center" style={{ ...statusKnopf, background: 'var(--pur-soft)', color: 'var(--pur)', opacity: isSaving || rechnung.status?.toLowerCase() === 'unklar' ? 0.4 : 1 }}>
                    <Sparkle size={15} weight="bold" />Unklar
                  </button>
                  <button type="button" onClick={() => setPaymentQRVisible(true)} data-tip="QR-Code – SEPA-Bezahlcode anzeigen"
                    className="inline-flex items-center justify-center" style={{ ...statusKnopf, background: 'var(--fill2)', color: 'var(--ink)' }}>
                    <QrCode size={15} weight="bold" />QR-Code
                  </button>
                  <button type="button" onClick={() => handleStatusUpdate(istKlaerung ? 'offen' : 'klaerung')} disabled={isSaving}
                    data-tip={istKlaerung ? undefined : 'Klärung – Beleg zur Klärung zurückstellen (Wiedervorlage in 7 Tagen)'}
                    className="inline-flex items-center justify-center" style={{ ...statusKnopf, background: 'var(--info-soft)', color: 'var(--info)', opacity: isSaving ? 0.5 : 1 }}>
                    <WarningCircle size={15} weight="bold" />{istKlaerung ? 'Klärung aufheben' : 'Klärungsbedarf'}
                  </button>
                </div>
                {istKlaerung && (
                  <div className="flex flex-col" style={{ gap: 8, padding: '10px 12px', borderRadius: 16, background: 'var(--info-soft)' }}>
                    <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--info)' }}>Wiedervorlage</span>
                    <div className="flex flex-wrap" style={{ gap: 6 }}>
                      {KLAERUNG_PRESETS.map((p) => (
                        <button key={p.tage} type="button" onClick={() => setzeKlaerungWiedervorlage(p.tage)} disabled={isSaving}
                          style={{ height: mobil ? 44 : 34, padding: '0 12px', borderRadius: 12, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 800, background: 'var(--sheet)', color: 'var(--info)' }}>
                          {p.label}
                        </button>
                      ))}
                      <input type="date" min={new Date().toISOString().slice(0, 10)} aria-label="Wiedervorlage am" disabled={isSaving}
                        onChange={(e) => { if (e.target.value) setzeKlaerungWiedervorlageDatum(e.target.value); }}
                        style={{ height: mobil ? 44 : 34, padding: '0 10px', borderRadius: 12, border: 'none', outline: 'none', background: 'var(--sheet)', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700, color: 'var(--ink)' }} />
                    </div>
                  </div>
                )}
              </Widget>
            )}

            {/* Workflow — nur wenn nicht bezahlt und kein KI-Pool */}
            {!pool && !isPaid && (
              <Widget titel="Workflow" icon={FlowArrow} farbe="#5856d6" gap={10}>
                {workflowState?.brauchtFreigabe && (
                  <div className="flex items-center" style={{ gap: 8, padding: '10px 12px', borderRadius: 14, fontSize: 12.5, fontWeight: 800,
                    background: workflowState.istFreigegeben ? 'var(--ok-soft)' : 'var(--warn-soft)', color: workflowState.istFreigegeben ? 'var(--ok)' : 'var(--warn)' }}>
                    {workflowState.istFreigegeben ? <ShieldCheck size={17} weight="fill" /> : <ShieldWarning size={17} weight="fill" />}
                    {workflowState.istFreigegeben ? 'Vier-Augen-Freigabe erteilt' : 'Vier-Augen-Freigabe erforderlich (≥ 3.000 €)'}
                  </div>
                )}
                {workflowState?.techPruefungLaeuft && (
                  <div className="flex items-center" style={{ gap: 8, padding: '10px 12px', borderRadius: 14, fontSize: 12.5, fontWeight: 800, background: 'var(--pur-soft)', color: 'var(--pur)' }}>
                    <ArrowsLeftRight size={16} weight="bold" />Sachliche &amp; rechnerische Prüfung läuft
                  </div>
                )}
                {rechnung.tech_pruefung_an === userProfile?.id && rechnung.tech_pruefung_status === 'angefordert' && (
                  <div className="flex flex-col" style={{ gap: 8, padding: 10, borderRadius: 16, background: 'var(--fill)' }}>
                    <textarea value={techKommentar} onChange={(e) => setTechKommentar(e.target.value)} rows={2} placeholder="Kommentar zur Prüfung (optional)..." aria-label="Kommentar zur Prüfung"
                      style={{ width: '100%', resize: 'none', border: 'none', outline: 'none', borderRadius: 12, padding: '8px 10px', background: 'var(--sheet)', fontFamily: 'inherit', fontSize: 13, color: 'var(--ink)' }} />
                    <div className="flex" style={{ gap: 6 }}>
                      <button type="button" onClick={() => handleTechPruefungAntwort('freigegeben')} disabled={workflowLoading} className="inline-flex flex-1 items-center justify-center" style={{ ...antwortKnopf, background: '#34c759', color: '#fff' }}><Check size={13} weight="bold" />Freigeben</button>
                      <button type="button" onClick={() => handleTechPruefungAntwort('abgelehnt')} disabled={workflowLoading} className="inline-flex flex-1 items-center justify-center" style={{ ...antwortKnopf, background: 'var(--bad-soft)', color: 'var(--bad)' }}><X size={13} weight="bold" />Ablehnen</button>
                    </div>
                  </div>
                )}
                {rechnung.freigabe_angefordert_an === userProfile?.id && !rechnung.freigegeben && (
                  <div className="flex" style={{ gap: 6 }}>
                    <button type="button" onClick={() => handleFreigabeAntwort('freigegeben')} disabled={workflowLoading} className="inline-flex flex-1 items-center justify-center" style={{ ...antwortKnopf, background: '#34c759', color: '#fff' }}><ShieldCheck size={14} weight="bold" />Freigeben</button>
                    <button type="button" onClick={() => handleFreigabeAntwort('abgelehnt')} disabled={workflowLoading} className="inline-flex flex-1 items-center justify-center" style={{ ...antwortKnopf, background: 'var(--bad-soft)', color: 'var(--bad)' }}><X size={14} weight="bold" />Ablehnen</button>
                  </div>
                )}
                <div className="flex flex-col" style={{ gap: 6 }}>
                  {!workflowState?.techPruefungLaeuft && rechnung.status !== 'bezahlt' && (
                    <AktionsZeile icon={Wrench} farbe="#af52de" label="Sachl. Prüfung" onClick={() => { setShowTechPruefungModal(true); setShowFreigabeModal(false); }}
                      tip="Sachl. Prüfung – sachliche & rechnerische Prüfung bei einer Kollegin oder einem Kollegen anfordern" />
                  )}
                  {showTechPruefungModal && (
                    <PersonWahl titel="Prüfer auswählen" wert={selectedPrueferId} onWert={setSelectedPrueferId} personen={teamMembers.filter(t => t.id !== userProfile?.id)}
                      sendenLabel="Senden" gesperrt={!selectedPrueferId || workflowLoading} onSenden={handleTechPruefungSenden}
                      onAbbrechen={() => { setShowTechPruefungModal(false); setSelectedPrueferId(null); }} />
                  )}
                  {workflowState?.brauchtFreigabe && !workflowState?.istFreigegeben && rechnung.status !== 'bezahlt' && !rechnung.freigabe_angefordert_an && (
                    <AktionsZeile icon={ShieldWarning} farbe="#ff3b30" label="Freigabe anfordern" onClick={() => { setShowFreigabeModal(true); setShowTechPruefungModal(false); }}
                      tip="Freigabe anfordern – Vier-Augen-Freigabe für Rechnungen ab 3.000 €" />
                  )}
                  {showFreigabeModal && (
                    <PersonWahl titel="Freigeber auswählen" wert={selectedFreigeberId} onWert={setSelectedFreigeberId} personen={teamMembers.filter(t => t.id !== userProfile?.id)}
                      sendenLabel="Anfordern" gesperrt={!selectedFreigeberId || workflowLoading} onSenden={handleFreigabeSenden}
                      onAbbrechen={() => { setShowFreigabeModal(false); setSelectedFreigeberId(null); }} />
                  )}
                  {workflowState?.kannBezahlen && rechnung.status !== 'bezahlt' && (
                    <AktionsZeile icon={CheckCircle} farbe="#34c759" label="Als bezahlt markieren" onClick={() => { void handleBezahlt(); }} gesperrt={workflowLoading} tip="Als bezahlt markieren" />
                  )}
                  <AktionsZeile icon={PaperPlaneTilt} farbe="#5e5ce6" label={weiterleitenLabel} onClick={handleWeiterleitenAnEigentuemer} gesperrt={workflowLoading}
                    tip={rechnung.weitergeleitet_am ? `Zuletzt weitergeleitet am ${new Date(rechnung.weitergeleitet_am).toLocaleDateString('de-DE')}` : 'Rechnung per E-Mail an den Eigentümer senden'} />
                </div>
              </Widget>
            )}

            {/* Pool-Belege haben keinen Workflow, senden können sie trotzdem (#419). */}
            {pool && (
              <AktionsZeile gross pfeil={false} icon={PaperPlaneTilt} farbe="#5e5ce6" label={weiterleitenLabel} onClick={handleWeiterleitenAnEigentuemer} gesperrt={workflowLoading}
                tip={rechnung.weitergeleitet_am ? `Zuletzt weitergeleitet am ${new Date(rechnung.weitergeleitet_am).toLocaleDateString('de-DE')}` : 'Beleg per E-Mail an den Eigentümer senden'} />
            )}

            {/* Korrektur-Verknüpfung: beide Richtungen sichtbar, obwohl nur korrigiert_durch_id gespeichert ist. */}
            {(korrekturPartner.nachfolger || korrekturPartner.vorgaenger || wartetAufKorrektur(rechnung)) && (
              <div className="flex flex-col" style={{ gap: 8, padding: '14px 16px', borderRadius: 24, background: 'var(--info-soft)' }}>
                {wartetAufKorrektur(rechnung) && !korrekturPartner.nachfolger && (
                  <>
                    <span className="flex items-center" style={{ gap: 7, fontSize: 14, fontWeight: 800, color: 'var(--info)' }}><ArrowCounterClockwise size={15} weight="bold" />Korrektur angefordert</span>
                    <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink2)' }}>
                      {rechnung.korrektur_angefordert_am ? new Date(rechnung.korrektur_angefordert_am).toLocaleDateString('de-DE') : ''}
                      {rechnung.korrektur_grund ? ` · ${rechnung.korrektur_grund}` : ''}
                    </span>
                    <div className="flex flex-wrap" style={{ gap: 6 }}>
                      <button type="button" onClick={() => setVerknuepfenOffen(true)} data-tip="Korrigierte Rechnung zuordnen – die eingetroffene Korrektur mit dieser Rechnung verknüpfen"
                        className="inline-flex items-center" style={{ ...korrKnopf, fontWeight: 800, background: 'var(--sheet)', color: 'var(--info)' }}>
                        <LinkIcon size={13} weight="bold" />Korrigierte Rechnung zuordnen
                      </button>
                      {/* Kommt die Korrektur nie, muss der Beleg zurück in die Eindeutigkeit. */}
                      <button type="button" onClick={handleKorrekturZurueckziehen} data-tip="Zurückziehen – die Rechnungsnummer zählt danach wieder als vergeben"
                        className="inline-flex items-center" style={{ ...korrKnopf, background: 'transparent', color: 'var(--ink2)' }}>
                        Zurückziehen
                      </button>
                    </div>
                  </>
                )}
                {korrekturPartner.nachfolger && (
                  <div className="flex items-center" style={{ gap: 6 }}>
                    <button type="button" onClick={() => navigate('/admin/rechnungen/' + korrekturPartner.nachfolger!.id)}
                      className="inline-flex flex-1 items-center" style={{ ...korrKnopf, fontWeight: 800, background: 'var(--sheet)', color: 'var(--info)' }}>
                      <ArrowBendUpRight size={13} weight="bold" />Ersetzt durch {korrekturPartner.nachfolger.rechnungsnummer}
                    </button>
                    <button type="button" onClick={handleVerknuepfungLoesen} data-tip="Verknüpfung lösen" className="inline-flex items-center" style={{ ...korrKnopf, background: 'transparent', color: 'var(--bad)' }}>
                      Lösen
                    </button>
                  </div>
                )}
                {korrekturPartner.vorgaenger && (
                  <button type="button" onClick={() => navigate('/admin/rechnungen/' + korrekturPartner.vorgaenger!.id)}
                    className="inline-flex items-center" style={{ ...korrKnopf, fontWeight: 800, background: 'var(--sheet)', color: 'var(--info)' }}>
                    <ArrowBendUpLeft size={13} weight="bold" />Ersetzt {korrekturPartner.vorgaenger.rechnungsnummer}
                  </button>
                )}
              </div>
            )}

            {/* „Korrektur anfordern“ bewusst unabhängig vom Zahlungsstatus (darfKorrekturAnfordern), auch im Pool (#419). */}
            {darfKorrekturAnfordern(rechnung) && (
              <AktionsZeile gross icon={ArrowCounterClockwise} farbe="#32ade6" label="Korrektur anfordern" onClick={() => setKorrekturOffen(true)} gesperrt={workflowLoading}
                tip="Korrektur anfordern – Lieferanten per E-Mail um eine korrigierte Fassung bitten (auch bei bezahlten und KI-Pool-Belegen)" />
            )}

            {/* Fristen & Termine */}
            <Widget titel="Fristen & Termine" icon={CalendarBlank} farbe="#ff9500" gap={2}
              rechts={faelligBadge ? (
                <span className="inline-flex shrink-0 items-center" style={{ height: 22, padding: '0 9px', borderRadius: 11, fontSize: 11, fontWeight: 800, color: '#fff',
                  background: faelligBadge === 'rot' ? 'var(--bad)' : 'var(--warn)' }}>
                  {faelligBadge === 'rot' ? 'Überfällig' : 'Bald fällig'}
                </span>
              ) : undefined}>
              <InfoZeile icon={TrayArrowDown} label="Eingangsdatum" wert={rechnung.created_at ? new Date(rechnung.created_at).toLocaleDateString('de-DE') : '-'} />
              <InfoZeile icon={CalendarBlank} label="Belegdatum" wert={new Date(rechnung.datum).toLocaleDateString('de-DE')} />
              <InfoZeile icon={Flag} label="Zahlungsziel" wert={rechnung.faelligkeitsdatum ? new Date(rechnung.faelligkeitsdatum).toLocaleDateString('de-DE') : 'In Prüfung'} letzte />
              {/* Ticket #421: die verknüpfte Mahnung gehört an die Rechnung (mahnung-zuordnung.ts). */}
              {(rechnung.mahnstufe ?? 0) > 0 && (
                <div className="flex items-center" style={{ marginTop: 8, gap: 9, padding: '10px 12px', borderRadius: 14, background: 'rgba(232,115,12,0.14)' }}>
                  <WarningCircle size={18} weight="fill" color="#e8730c" className="shrink-0" />
                  <span className="flex min-w-0 flex-1 flex-col">
                    <span style={{ fontSize: 13, fontWeight: 800, color: '#e8730c' }}>{mahnLabel(rechnung)}</span>
                    <span style={{ fontSize: 12, color: 'var(--ink2)' }}>
                      {rechnung.letzte_mahnung_am ? `Mahnschreiben vom ${new Date(rechnung.letzte_mahnung_am).toLocaleDateString('de-DE')}` : 'Mahnschreiben erhalten'}
                    </span>
                  </span>
                  {rechnung.mahnung_url && (
                    <button type="button" onClick={() => window.open(rechnung.mahnung_url as string, '_blank')}
                      style={{ height: mobil ? 44 : 32, padding: '0 10px', borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 800, background: 'var(--sheet)', color: '#e8730c' }}>
                      Schreiben öffnen
                    </button>
                  )}
                </div>
              )}
              {isPaid && rechnung.bezahlt_timestamp && (
                <div className="flex items-center" style={{ marginTop: 8, gap: 9, padding: '10px 12px', borderRadius: 14, background: 'var(--ok-soft)' }}>
                  <CheckCircle size={18} weight="fill" color="var(--ok)" className="shrink-0" />
                  <span className="flex flex-col">
                    <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ok)' }}>Bezahlt am</span>
                    <span style={{ fontSize: 13, fontWeight: 800 }}>
                      {new Date(rechnung.bezahlt_timestamp).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </span>
                </div>
              )}
            </Widget>

            {/* Zuweisung */}
            <Widget titel="Zuweisung" icon={Buildings} farbe="#0a84ff" gap={8}>
              <button type="button" disabled={!rechnung.objekt_id} data-tip={rechnung.objekt_id ? 'Objekt – öffnet die Objektseite' : undefined}
                onClick={() => { if (rechnung.objekt_id && onObjectClick) { onObjectClick(rechnung.objekt_id); onClose(); } }}
                className={`${rechnung.objekt_id ? 'immo-zeile-hover ' : ''}flex w-full items-center text-left`} style={{ ...zuwKachel, cursor: rechnung.objekt_id ? 'pointer' : 'default' }}>
                <Buildings size={18} weight="fill" color="var(--acc)" className="shrink-0" />
                <span className="flex min-w-0 flex-1 flex-col">
                  <span style={zuwLabel}>Objekt</span>
                  <span className="truncate" style={zuwWert}>{currentObjekt?.bezeichnung || objektSearch || 'Nicht zugewiesen'}</span>
                </span>
                {rechnung.objekt_id && <ArrowSquareOut size={13} weight="bold" color="var(--ink3)" className="shrink-0" />}
              </button>
              {/* Auto-Match-Vorschlag, wenn objekt_id leer, aber über die Adresse ein Objekt gefunden wurde */}
              {!rechnung.objekt_id && matchedObjekt && (
                <div className="flex items-center" style={{ ...zuwKachel, background: 'var(--acc-soft)' }}>
                  <Sparkle size={16} weight="fill" color="var(--acc)" className="shrink-0" />
                  <span className="flex min-w-0 flex-1 flex-col">
                    <span style={{ ...zuwLabel, color: 'var(--acc)' }}>Auto-erkannt aus Adresse</span>
                    <span className="truncate" style={{ fontSize: 13, fontWeight: 800 }}>№ {matchedObjekt.objektnummer} · {matchedObjekt.bezeichnung}</span>
                  </span>
                  <button type="button" data-tip="Übernehmen – erkanntes Objekt in die Bearbeitung übernehmen"
                    onClick={() => { setSelectedObjektId(matchedObjekt.id); setObjektSearch(matchedObjekt.bezeichnung || ''); setIsEditing(true); }}
                    style={{ height: mobil ? 44 : 32, padding: '0 10px', borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 800, background: 'var(--acc-fill)', color: 'var(--acc-ink)' }}>
                    Übernehmen
                  </button>
                </div>
              )}
              <div className="flex items-center" style={zuwKachel}>
                {currentOwnerName && istFirma(currentOwnerName) ? <Buildings size={18} weight="fill" color="var(--acc)" className="shrink-0" /> : <UserCircle size={18} weight="fill" color="var(--acc)" className="shrink-0" />}
                <span className="flex min-w-0 flex-1 flex-col">
                  <span style={zuwLabel}>Eigentümer</span>
                  <span className="truncate" style={zuwWert}>{currentOwnerName ? eigentuemerAnzeigename(currentOwnerName) : ownerSearch || 'Nicht zugewiesen'}</span>
                  {currentOwnerName && ansprechpartnerZusatz(currentOwnerName) && (
                    <span className="truncate" style={{ fontSize: 11.5, color: 'var(--ink3)' }}>Ansprechpartner: {ansprechpartnerZusatz(currentOwnerName)}</span>
                  )}
                </span>
              </div>
              <label className="relative flex items-center" style={{ ...zuwKachel, cursor: 'pointer' }}>
                <UserCheck size={18} weight="fill" color="var(--acc)" className="shrink-0" />
                <span className="flex min-w-0 flex-1 flex-col">
                  <span style={zuwLabel}>Zuständig</span>
                  <select
                    value={selectedZustaendigId ? (selectedZustaendigTyp === 'team' ? 't:' + selectedZustaendigId : 'p:' + selectedZustaendigId) : ''}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (!v) handleZustaendigDirect(null, null);
                      else if (v.startsWith('t:')) handleZustaendigDirect(v.slice(2), 'team');
                      else handleZustaendigDirect(v.slice(2), 'mitarbeiter');
                    }}
                    disabled={isSaving} aria-label="Zuständig"
                    style={{ border: 'none', outline: 'none', background: 'transparent', padding: 0, minHeight: mobil ? 28 : undefined, fontFamily: 'inherit', fontSize: 13.5, fontWeight: 800, color: 'var(--ink)', cursor: 'pointer', opacity: isSaving ? 0.5 : 1 }}>
                    <option value="">Global</option>
                    <optgroup label="Mitarbeiter">
                      {teamMembers.map(m => <option key={m.id} value={'p:' + m.id}>{m.full_name}</option>)}
                    </optgroup>
                    <optgroup label="Teams">
                      {teams.map(t => <option key={t.id} value={'t:' + t.id}>{t.name}</option>)}
                    </optgroup>
                  </select>
                </span>
                {isSaving ? <CircleNotch size={13} weight="bold" color="var(--acc)" className="animate-spin shrink-0" /> : <CaretUpDown size={13} weight="bold" color="var(--ink3)" className="shrink-0" />}
              </label>
            </Widget>
          </div>
        </div>
      )}

      <PaymentQRModal
        isOpen={paymentQRVisible}
        onClose={() => setPaymentQRVisible(false)}
        onSuccess={() => { onRefresh?.(); }}
        rechnung={rechnung}
        huelle="app"
        melde={(t: string) => melde(t, true)}
        // Entscheidung 17.10.2026: auch „Als bezahlt markieren“ im QR-Dialog läuft über
        // markAsBezahlt — mit Vier-Augen-Prüfung ab 3.000 €, bezahlt_von und Verlaufseintrag.
        onAlsBezahlt={handleBezahlt}
      />

      {showDeleteConfirm && (
        <BestaetigenDialog titel="Beleg löschen" bestaetigenLabel="Löschvorgang bestätigen" laeuft={isDeleting}
          text={`Möchten Sie den Beleg ${rechnung.rechnungsnummer} von ${rechnung.unternehmen} wirklich unwiderruflich löschen?`}
          onBestaetigen={confirmDelete} onAbbrechen={() => setShowDeleteConfirm(false)} />
      )}

      {korrekturOffen && rechnung && (
        <KorrekturAnfordernModal
          rechnungsnummer={rechnung.rechnungsnummer}
          onClose={() => setKorrekturOffen(false)}
          onWeiter={handleKorrekturAnfordern}
        />
      )}

      {verknuepfenOffen && rechnung && (
        <KorrekturVerknuepfenModal
          eigeneId={rechnung.id}
          onClose={() => setVerknuepfenOffen(false)}
          onWaehlen={handleVerknuepfungWaehlen}
        />
      )}
      {dialoge}
    </div>
  );
};

const FELD: React.CSSProperties = {
  height: 46, padding: '0 14px', borderRadius: 14, border: 'none', outline: 'none', background: 'var(--fill)', boxShadow: 'inset 0 0 0 1px var(--line)',
  fontFamily: 'inherit', fontSize: 14, fontWeight: 700, color: 'var(--ink)', width: '100%', minWidth: 0,
};
const FELD_LABEL: React.CSSProperties = { fontSize: 12, fontWeight: 700, color: 'var(--ink3)' };
const AUSWAHL_LISTE: React.CSSProperties = {
  left: 0, right: 0, top: 74, zIndex: 30, maxHeight: 280, overflowY: 'auto', gap: 2, padding: 6, borderRadius: 16,
  background: 'var(--sheet)', boxShadow: '0 24px 50px -16px var(--shade), inset 0 0 0 1px var(--line)',
};
const AUSWAHL_ZEILE: React.CSSProperties = {
  gap: 8, minHeight: 40, padding: '8px 10px', borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: 'inherit', color: 'var(--ink)', background: 'transparent',
};

function AuswahlZeile({ icon: I, label, an, onClick }: { icon: PhIcon; label: string; an: boolean; onClick: () => void }) {
  return (
    <button type="button" role="option" aria-selected={an} onClick={onClick} className="immo-zeile-hover flex items-center text-left"
      style={{ ...AUSWAHL_ZEILE, fontSize: 13, fontWeight: 700, background: an ? 'var(--acc-soft)' : 'transparent' }}>
      <I size={13} weight="bold" color="var(--acc)" className="shrink-0" />
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {an && <Check size={12} weight="bold" color="var(--acc)" className="shrink-0" />}
    </button>
  );
}

/** Auswahl Prüfer/Freigeber im Workflow-Widget („— Bitte wählen —“, ohne mich), wie bisher inline. */
function PersonWahl({ titel, wert, onWert, personen, sendenLabel, gesperrt, onSenden, onAbbrechen }: {
  titel: string; wert: string | null; onWert: (v: string | null) => void; personen: { id: string; full_name: string }[];
  sendenLabel: string; gesperrt: boolean; onSenden: () => void; onAbbrechen: () => void;
}) {
  return (
    <div className="immo-pop-in flex flex-col" style={{ gap: 8, padding: 10, borderRadius: 16, background: 'var(--fill)' }}>
      <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--ink3)' }}>{titel}</span>
      <select value={wert || ''} onChange={(e) => onWert(e.target.value || null)} aria-label={titel}
        style={{ height: 44, padding: '0 10px', borderRadius: 12, border: 'none', outline: 'none', background: 'var(--sheet)', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 700, color: 'var(--ink)' }}>
        <option value="">— Bitte wählen —</option>
        {personen.map(t => <option key={t.id} value={t.id}>{t.full_name}</option>)}
      </select>
      <div className="flex" style={{ gap: 6 }}>
        <button type="button" onClick={onSenden} disabled={gesperrt}
          style={{ flex: 1, height: 44, borderRadius: 12, border: 'none', cursor: gesperrt ? 'default' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 800, background: 'var(--acc-fill)', color: 'var(--acc-ink)', opacity: gesperrt ? 0.45 : 1 }}>
          {sendenLabel}
        </button>
        <button type="button" onClick={onAbbrechen}
          style={{ flex: 1, height: 44, borderRadius: 12, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, background: 'var(--fill2)', color: 'var(--ink)' }}>
          Abbrechen
        </button>
      </div>
    </div>
  );
}

// Extrahiert die Google-Drive-File-ID aus einer Datei-URL (z. B. ".../file/d/<ID>/view").
// Liefert null bei Nicht-Drive-URLs (z. B. SharePoint/OneDrive-Altbestände).
const getDriveFileId = (url: string | null | undefined): string | null => {
  if (!url) return null;
  const match = url.match(/\/file\/d\/([^/]+)/);
  return match ? match[1] : null;
};

// Deutsche Betragseingabe ("1.234,56" / "102,01") → Zahl
const parseBetrag = (s: string): number | null => {
  const cleaned = String(s).trim().replace(/\s/g, '').replace(/\./g, '').replace(',', '.');
  if (cleaned === '') return null;
  const n = parseFloat(cleaned);
  return isNaN(n) ? null : n;
};

export default RechnungDetailsSidebar;
